import React, { ReactElement } from 'react';

import { Box, useTheme } from '@bcp-nextgen-dx-component-factory/design-system';
import { DisplayGroupProps } from '@bcp-nextgen-dx-touchpoint-framework/react-js';
import { ComponentInfo, DisplayGroupRender } from '@components';

import { usePageContainerHelper } from './pageContainer.helper';

export const PageContainer: React.FC<DisplayGroupProps> = (props: DisplayGroupProps): ReactElement => {
	usePageContainerHelper();
	const { colorPalette } = useTheme();

	return (
		<ComponentInfo
			name="PageContainer"
			as={Box}
			styles={{
				position: 'relative',
				minWidth: '100vw',
				minHeight: '100vh',
				display: 'flex',
				flexDirection: 'column',
				background: colorPalette.color_01[70],
			}}
		>
			<DisplayGroupRender displayGroupsProps={props} />
		</ComponentInfo>
	);
};
